import TextField from "@material-ui/core/TextField";

const Input = ({ handleOnSubmit, inputValue, setInputValue, label }) => (
  <form onSubmit={handleOnSubmit}>
    <TextField
      onChange={(e) => setInputValue(e.target.value)}
      value={inputValue}
      label={label}
      variant="outlined"
    />
  </form>
);

export default Input;
